import {
  dashboardDocumentSchema,
  DashboardDateScopeMode,
  DashboardMetric,
  DashboardPublisherColumn,
  DashboardWidgetAction,
  DashboardWidgetType,
  DashboardWidgetWidth,
} from './model';

export const defaultDashboardDocument = dashboardDocumentSchema.parse({
  version: 1,
  widgets: [
    metric('ad-requests', DashboardMetric.AdRequests),
    metric('ad-impressions', DashboardMetric.AdImpressions),
    metric('fill-rate', DashboardMetric.FillRate),
    metric('rpm', DashboardMetric.Rpm),
    metric('revenue', DashboardMetric.Revenue),
    metric('profit', DashboardMetric.Profit),
    {
      id: 'performance',
      type: DashboardWidgetType.PerformanceChart,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit(),
      metrics: [
        DashboardMetric.AdRequests,
        DashboardMetric.AdImpressions,
        DashboardMetric.FillRate,
        DashboardMetric.Rpm,
        DashboardMetric.Srpm,
        DashboardMetric.Revenue,
        DashboardMetric.PublisherRevenue,
        DashboardMetric.Profit,
      ],
      defaultVisibleMetrics: [DashboardMetric.PublisherRevenue, DashboardMetric.AdImpressions],
      actions: [DashboardWidgetAction.ViewInReporting, DashboardWidgetAction.PerformanceAnalyzer],
    },
    {
      id: 'publisher-performance',
      type: DashboardWidgetType.PublisherPerformance,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit(),
      columns: [
        DashboardPublisherColumn.Publisher,
        DashboardPublisherColumn.AdRequests,
        DashboardPublisherColumn.AdImpressions,
        DashboardPublisherColumn.FillRate,
        DashboardPublisherColumn.Rpm,
        DashboardPublisherColumn.Srpm,
        DashboardPublisherColumn.RevenuePercentage,
        DashboardPublisherColumn.MarginPercentage,
        DashboardPublisherColumn.Revenue,
        DashboardPublisherColumn.PublisherRevenue,
        DashboardPublisherColumn.Profit,
      ],
      pageSize: 10,
      actions: [DashboardWidgetAction.ViewInReporting],
    },
    {
      id: 'demand-partners',
      type: DashboardWidgetType.DemandPartners,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit(),
      pageSize: 10,
      actions: [DashboardWidgetAction.ViewInReporting],
    },
    {
      id: 'demand-integrations',
      type: DashboardWidgetType.DemandIntegrations,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit(),
      pageSize: 10,
      actions: [DashboardWidgetAction.ViewInReporting],
    },
    {
      id: 'srpm-ranking',
      type: DashboardWidgetType.SrpmRanking,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit(),
      pageSize: 10,
      actions: [DashboardWidgetAction.ViewInReporting],
    },
  ],
});

function metric(id: string, value: DashboardMetric) {
  return {
    id,
    type: DashboardWidgetType.Metric,
    width: DashboardWidgetWidth.Sixth,
    dateScope: inherit(),
    metric: value,
  } as const;
}

function inherit() {
  return { mode: DashboardDateScopeMode.Inherit } as const;
}
